import { useContext } from 'react';
import { createPortal } from 'react-dom';

import { Button } from '@/components/ui/Button';
import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { BrowserRequestPresentationContext } from './browser-request-presentation';

export const CredentialNotificationRetry = ({
  pending,
  isError,
  onRetry,
}: {
  pending: boolean;
  isError: boolean;
  onRetry: () => void;
}) => {
  const presentation = useContext(BrowserRequestPresentationContext);
  const inlineTarget = presentation?.inlineTarget;
  if (presentation && !inlineTarget) return null;
  const content = (
    <XStack
      className={cn(
        'flex-wrap items-center justify-between gap-4 rounded-xl border border-border-strong bg-surface p-4 text-foreground',
        inlineTarget ? 'w-full' : 'absolute inset-x-3 bottom-3 z-10 shadow-lg'
      )}
    >
      <p
        role="alert"
        className="min-w-0 flex-1 basis-48 text-sm leading-relaxed"
      >
        {isError
          ? 'Couldn’t notify the agent. Please retry.'
          : 'The agent hasn’t received your response yet.'}
      </p>
      <Button
        className="min-h-11 shrink-0"
        disabled={pending}
        onClick={onRetry}
      >
        Retry
      </Button>
    </XStack>
  );
  return inlineTarget ? createPortal(content, inlineTarget) : content;
};
